module.exports = __webpack_public_path__ + "05ff1d01a83b689a61e031eec5fa0f70.MP3";